export enum Role {
    User = 'user',
    Admin = 'admin',
    Manager = 'manager',
    SUPER_ADMIN = 'SUPER_ADMIN',
}
